﻿import { IContact } from './contact';

export interface IDutyOfficerSchedule {
    id: number,
    dayId: number,
    startTime: string,
    startTimeRaw: number,
    endTime: string,
    endTimeRaw: number,
    officerId: number,
    officer: IContact
}
